import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfileRoutingModule } from './profile-routing.module';
import { ProfileFormComponent } from './profile-form/profile-form.component';
import { ProfileParentComponent } from './profile-parent/profile-parent.component';
import { FormsModule } from '@angular/forms';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { FeatureFlagDirective } from 'src/app/directives/feature-flag.directive';


@NgModule({
  declarations: [
    ProfileFormComponent,
    ProfileParentComponent,
    AccountSettingsComponent,
    FeatureFlagDirective  
  ],
  imports: [
    CommonModule,
    ProfileRoutingModule,
    FormsModule,
    SharedComponentsModule
  ]
})
export class ProfileModule { }
